import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useUser } from '../../contexts/userContext';
import { useCard } from '../../contexts/cardContext';
import { useColumns } from '../../contexts/columnsContext';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { MdOutlineArrowBackIos, MdSend, MdCheck } from "react-icons/md";
import PreviewCard from '../PreviewCard';
import './style.css';
import axios from 'axios';
import { apiUrl } from '../../config/apiConfig';

import { TbCheck, TbChecks } from "react-icons/tb";

import { IoReturnDownBack } from "react-icons/io5";


import logo from '../../assets/logo-suite-flow.ico'
import api from '../../services/api';


function Messenger({ closeModal }) {
  const { user, listAllUsers, openCloseModalMessage, setOpenCloseModalMessage } = useUser();
  const { currentCardIdMessage, setCurrentCardIdMessage, openCloseModalMessenger, addHistoricoCardSemUpdatedAtContext } = useCard();
  const { columnsUser, columns } = useColumns();
  // const [openCloseModalMessage, setOpenCloseModalMessage] = useState(false);
  const [destinatarioName, setDestinatarioName] = useState('');
  const [destinatarioAvatar, setDestinatarioAvatar] = useState(null);
  const [destinatarioId, setDestinatarioId] = useState(null);
  const [message, setMessage] = useState('');
  const [listMessages, setListMessages] = useState([]);
  const messagesEndRef = useRef(null);
  const messageInputRef = useRef(null);

  const [loadingMessage, setLoadingMessage] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');




  const [searchInMessages, setSearchInMessages] = useState('');
  const [foundMessages, setFoundMessages] = useState([]);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(0);


  const [replyMessage, setReplyMessage] = useState(null);

  const [visibleCount, setVisibleCount] = useState(50); // Começa com 50 mensagens

  const [isCardDataLoaded, setIsCardDataLoaded] = useState(false);
  
  const [isLoadingMoreMessages, setIsLoadingMoreMessages] = useState(false);
  
  const [scrollPositionRef, setScrollPositionRef] = useState(null);
  
  const [shouldMaintainScroll, setShouldMaintainScroll] = useState(false);
  const [savedScrollPosition, setSavedScrollPosition] = useState(0);








  function rolagemAutomatica() {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Função para ajustar automaticamente a altura do textarea
  const adjustTextareaHeight = () => {
    const textarea = messageInputRef.current;
    if (textarea) {
      // Reset altura para calcular a altura necessária
      textarea.style.height = '40px';
      
      // Calcula a nova altura baseada no conteúdo
      const scrollHeight = textarea.scrollHeight;
      const minHeight = 40;
      const maxHeight = 120;
      
      // Define a nova altura respeitando os limites
      const newHeight = Math.max(minHeight, Math.min(scrollHeight, maxHeight));
      textarea.style.height = newHeight + 'px';
      
      // Controla o overflow baseado na altura
      textarea.style.overflowY = scrollHeight > maxHeight ? 'auto' : 'hidden';
    }
  };

  // useEffect para ajustar altura quando a mensagem muda
  useEffect(() => {
    adjustTextareaHeight();
  }, [message]);

  const [currentListaCount, setCurrentListaCount] = useState(0);


  useEffect(() => {

    let lista = listMessages.length;

    if (currentListaCount != lista) {
      setCurrentListaCount(lista);
      rolagemAutomatica();

    }


  }, [listMessages]);













  useEffect(() => {
    if (currentCardIdMessage && destinatarioId) {
      const cardMessage = `card_id:${currentCardIdMessage}`;
      sendMessage(cardMessage);
    }
  }, [currentCardIdMessage, destinatarioId]);


  async function openMessage(item) {
    setListMessages([]);
    setVisibleCount(50); // Reset do contador de mensagens visíveis
    setDestinatarioName(item.username);
    setDestinatarioAvatar(item.avatar);
    setDestinatarioId(item.id);
    setOpenCloseModalMessage(true);
    await fetchMessages(item.id);
    await markMessagesAsRead(user.id, item.id); // Mover esta linha para o final de fetchMessages
  }



  // const sendMessage = async (mensagem) => {
  //   if (mensagem.trim() === "") return;

  //   if (containsForbiddenWords(mensagem)) {
  //     alert("Sua mensagem contém palavras proibidas e não pode ser enviada.");
  //     return;
  //   }

  //   const isCardMessage = mensagem.includes("card_id:");
  //   let cardData = null;

  //   if (isCardMessage) {
  //     const cardId = mensagem.split("card_id:")[1].trim();
  //     cardData = await fetchCardById(cardId);
  //   }

  //   // Pegamos o ID da mensagem que está sendo respondida
  //   const replyToId = replyMessage ? replyMessage.id : null;

  //   // Atualização otimista da interface do usuário
  //   const tempMessage = {
  //     id: `temp-${new Date().getTime()}`,
  //     message: mensagem,
  //     id_remetente: user.id,
  //     id_destinatario: destinatarioId,
  //     created_at: new Date().toISOString(),
  //     read: false,
  //     cardData: isCardMessage ? cardData : null,
  //     reply_to: replyToId,
  //   };
  //   setListMessages((prev) => [...prev, tempMessage]);
  //   setMessage("");
  //   setReplyMessage(null); // Limpa a mensagem que estávamos respondendo

  //   try {
  //     const dados = {
  //       id_remetente: user.id,
  //       id_destinatario: destinatarioId,
  //       message: mensagem,
  //       read: false,
  //       card_id: isCardMessage ? cardData.card_id : null,
  //       empresa_id: user.empresa_id,
  //       reply_to: replyToId, // Enviamos o ID da mensagem que está sendo respondida
  //     };

  //     const response = await api.post("/card/add-messenger", dados);

  //     // Atualiza a mensagem otimista com os dados reais do servidor
  //     setListMessages((prev) =>
  //       prev.map((msg) =>
  //         msg.id === tempMessage.id
  //           ? { ...msg, id: response.data.id, created_at: response.data.created_at }
  //           : msg
  //       )
  //     );

  //     // Registra no histórico se a mensagem compartilhada possui um `card_id`
  //     if (isCardMessage) {
  //       addHistoricoCardSemUpdatedAtContext(
  //         `Compartilhado via Messenger com ${getUserName(destinatarioId)} por ${getUserName(user.id)}`,
  //         cardData.card_id,
  //         user.id
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Erro ao enviar mensagem:", error);
  //     // Remove a mensagem otimista em caso de erro
  //     setListMessages((prev) => prev.filter((msg) => msg.id !== tempMessage.id));
  //   }
  // };

  const sendMessage = async (mensagem) => {
    if (mensagem.trim() === "") return;
  
    if (containsForbiddenWords(mensagem)) {
      alert("Sua mensagem contém palavras proibidas e não pode ser enviada.");
      return;
    }
  
    const isCardMessage = mensagem.includes("card_id:");
    let cardData = null;
  
    if (isCardMessage) {
      const cardId = mensagem.split("card_id:")[1].trim();
      cardData = await fetchCardById(cardId);
      
      // Filtra mensagens do usuário atual para o mesmo destinatário
      const myMessagesToRecipient = listMessages.filter(msg => 
        msg.id_remetente === user.id && msg.id_destinatario === destinatarioId
      );
      
      // Busca a última mensagem enviada pelo usuário atual para o mesmo destinatário
      const lastMessageToSameRecipient = myMessagesToRecipient[myMessagesToRecipient.length - 1];
      
      // NOVA LÓGICA: Bloqueia apenas se a última mensagem foi um card E é o mesmo card
      const isLastMessageSameCard = lastMessageToSameRecipient?.cardData?.card_id == cardId;
      const isLastMessageACard = !!lastMessageToSameRecipient?.cardData;
      
      console.log("DEBUG - Card ID tentando enviar:", cardId);
      console.log("DEBUG - Última mensagem:", lastMessageToSameRecipient?.message);
      console.log("DEBUG - Última mensagem é um card?", isLastMessageACard);
      console.log("DEBUG - Última mensagem é o mesmo card?", isLastMessageSameCard);
      
      if (isLastMessageACard && isLastMessageSameCard) {
        console.log("DEBUG - BLOQUEANDO: último envio foi o mesmo card");
        alert("Você não pode compartilhar o mesmo card duas vezes seguidas na mesma conversa.");
        return;
      } else {
        console.log("DEBUG - PERMITINDO: última mensagem não foi o mesmo card");
      }
    }
  
    const replyToId = replyMessage ? replyMessage.id : null;
  
    const tempMessage = {
      id: `temp-${new Date().getTime()}`,
      message: mensagem,
      id_remetente: user.id,
      id_destinatario: destinatarioId,
      created_at: new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }),
      read: false,
      cardData: isCardMessage ? cardData : null,
      reply_to: replyToId,
    };
  
    setListMessages((prev) => [...prev, tempMessage]);
    setMessage("");
    setReplyMessage(null);
  
    try {
      const dados = {
        id_remetente: user.id,
        id_destinatario: destinatarioId,
        message: mensagem,
        read: false,
        card_id: isCardMessage ? cardData.card_id : null,
        empresa_id: user.empresa_id,
        reply_to: replyToId,
      };
  
      const response = await api.post("/card/add-messenger", dados);
  
      setListMessages((prev) =>
        prev.map((msg) =>
          msg.id === tempMessage.id
            ? { ...msg, id: response.data.id, created_at: response.data.created_at }
            : msg
        )
      );
  
      if (isCardMessage) {
        addHistoricoCardSemUpdatedAtContext(
          `Compartilhado via Messenger com ${getUserName(destinatarioId)} por ${getUserName(user.id)}`,
          cardData.card_id,
          user.id
        );
      }
    } catch (error) {
      console.error("Erro ao enviar mensagem:", error);
      setListMessages((prev) => prev.filter((msg) => msg.id !== tempMessage.id));
    }
  };
  


  function handleKeyPress(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // Previne quebra de linha
      sendMessage(message);
    }
  }

  function formatDate(dateString) {
    try {
      const date = new Date(dateString);
      return format(date, 'dd/MM/yyyy - HH:mm:ss');
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      return dateString;
    }
  }

  // const fetchMessages = async (destinoId) => {
  //   setLoadingMessage(true)
  //   if (destinoId) {
  //     try {
  //       const response = await axios.get(`${apiUrl}/card/fetch-messages/${user.id}/${destinoId}`);
  //       const messagesWithCards = await Promise.all(
  //         response.data.map(async (msg) => {
  //           if (msg.message.includes('card_id:')) {
  //             const cardId = msg.message.split('card_id:')[1].trim();
  //             const cardData = await fetchCardById(cardId);
  //             return { ...msg, cardData };
  //           }
  //           return msg;
  //         })
  //       );
  //       setListMessages(messagesWithCards);
  //       setLoadingMessage(false)
  //       await markMessagesAsRead(user.id, destinoId);
  //     } catch (error) {
  //       console.error('Erro', error);
  //     }
  //   }

  // };

  // const fetchMessages = async (destinoId) => {
  //   setLoadingMessage(true);

  //   if (destinoId) {
  //     try {
  //       const response = await api.get(`/card/fetch-messages/${user.id}/${destinoId}`);

  //       const messagesWithCards = await Promise.all(
  //         response.data.map(async (msg) => {
  //           if (msg.message.includes("card_id:")) {
  //             const cardId = msg.message.split("card_id:")[1].trim();
  //             const cardData = await fetchCardById(cardId);
  //             return { ...msg, cardData };
  //           }
  //           return msg;
  //         })
  //       );

  //       setListMessages(messagesWithCards);
  //       setLoadingMessage(false);
  //       await markMessagesAsRead(user.id, destinoId);
  //     } catch (error) {
  //       console.error("Erro ao buscar mensagens:", error);
  //       setLoadingMessage(false);
  //     }
  //   }
  // };

  const fetchMessages = async (destinoId) => {
    setLoadingMessage(true);
    setIsCardDataLoaded(false); // Reseta o estado ao buscar novas mensagens

    if (destinoId) {
      try {
        const response = await api.get(`/card/fetch-messages/${user.id}/${destinoId}`);

        const messagesWithCards = await Promise.all(
          response.data.map(async (msg) => {
            if (msg.message.includes("card_id:")) {
              const cardId = msg.message.split("card_id:")[1].trim();
              const cardData = await fetchCardById(cardId); // Chama a função
              return { ...msg, cardData };
            }
            return msg;
          })
        );

        setListMessages(messagesWithCards);
        setLoadingMessage(false);
        setIsCardDataLoaded(true); // Define como true quando os dados estão prontos
        await markMessagesAsRead(user.id, destinoId);
      } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
        setLoadingMessage(false);
        setIsCardDataLoaded(true); // Mesmo em erro, permite renderizar
      }
    }
  };


  // const fetchCardById = async (cardId) => {
  //   try {
  //     const response = await axios.get(`${apiUrl}/card/search-card-id`, {
  //       params: {
  //         card_id: cardId,
  //         entityId: user.id,
  //         empresaId: user.empresa_id,
  //       },
  //     });
  //     return response.data[0];
  //   } catch (error) {
  //     console.error('Erro ao buscar card:', error);
  //   }
  // };

  // const fetchCardById = async (cardId) => {
  //   try {
  //     const response = await api.get("/card/search-card-id", {
  //       params: {
  //         card_id: cardId,
  //         entityId: user.id,
  //         empresaId: user.empresa_id,
  //       },
  //     });
  //     return response.data[0];
  //   } catch (error) {
  //     console.error("Erro ao buscar card:", error);
  //   }
  // };

  const fetchCardById = async (cardId) => {
    try {
      const response = await api.get("/card/search-card-id", {
        params: {
          card_id: cardId,
          entityId: user.id,
          empresaId: user.empresa_id,
        },
      });

      const card = response.data && response.data[0] ? response.data[0] : null;
      return card && card.column_id ? card : {};
    } catch (error) {
      console.error("Erro ao buscar card:", error);
      return {};
    }
  };



  const clearIdCardMessage = () => {
    setCurrentCardIdMessage(null);
    closeModal();
  };

  // useEffect(() => {
  //   let interval;
  //   if (destinatarioId) {
  //     fetchMessages(destinatarioId);
  //     interval = setInterval(() => {
  //       fetchMessages(destinatarioId);
  //     }, 5000);
  //   }
  //   return () => clearInterval(interval);
  // }, [destinatarioId]);



  // ---------------- mensagens não lidas -----------

  // const markMessagesAsRead = async (userId, destinatarioId) => {

  //   if (openCloseModalMessage) {
  //     try {
  //       await axios.put(`${apiUrl}/card/mark-messages-as-read/${userId}/${destinatarioId}`);
  //     } catch (error) {
  //       console.error('Erro ao marcar mensagens como lidas', error);
  //     }
  //   }
  // };


  const markMessagesAsRead = async (userId, destinatarioId) => {
    if (openCloseModalMessage) {
      try {
        await api.put(`/card/mark-messages-as-read/${userId}/${destinatarioId}`);
      } catch (error) {
        console.error("Erro ao marcar mensagens como lidas:", error);
      }
    }
  };

  const markMessagesAsUnread = async (userId, destinatarioId) => {
    try {
      await api.put(`/card/mark-messages-as-unread/${userId}/${destinatarioId}`);
      // Atualiza a contagem de mensagens não lidas após marcar como não lida
      await fetchUnreadMessagesForUsers();
    } catch (error) {
      console.error("Erro ao marcar mensagens como não lidas:", error);
    }
  };


  const [userUnreadMessages, setUserUnreadMessages] = useState({});
  const [userLastMessages, setUserLastMessages] = useState({});
  const [isLoadingConversations, setIsLoadingConversations] = useState(false);


  useEffect(() => {
    let intervalMessage;
    if (openCloseModalMessenger) {
      // Busca mensagens não lidas imediatamente e a cada 5 segundos
      fetchUnreadMessagesForUsers();
      intervalMessage = setInterval(() => {
        fetchUnreadMessagesForUsers();
      }, 5000);
      
      // Busca últimas mensagens apenas uma vez para ordenação
      fetchLastMessagesForUsers();
    }

    return () => clearInterval(intervalMessage);
  }, [openCloseModalMessenger]);



  // const fetchUnreadMessagesForUsers = async () => {
  //   if (openCloseModalMessenger) {

  //     try {
  //       const responses = await Promise.all(
  //         listAllUsers.map(async (item) => {
  //           const response = await axios.get(`${apiUrl}/card/unread-messages-count/${user.id}/${item.id}`);
  //           return { userId: item.id, unreadCount: response.data };
  //         })
  //       );
  //       const unreadMessagesMap = {};
  //       responses.forEach(res => {
  //         unreadMessagesMap[res.userId] = res.unreadCount;
  //       });
  //       setUserUnreadMessages(unreadMessagesMap);
  //     } catch (error) {
  //       console.error('Erro ao buscar contagem de mensagens não lidas por usuário', error);
  //     }
  //   }
  // };

  // Função para buscar apenas mensagens não lidas (chamada a cada 5 segundos)
  const fetchUnreadMessagesForUsers = async () => {
    if (openCloseModalMessenger) {
      try {
        const responses = await Promise.all(
          listAllUsers.map(async (item) => {
            const unreadResponse = await api.get(`/card/unread-messages-count/${user.id}/${item.id}`);
            return { 
              userId: item.id, 
              unreadCount: unreadResponse.data
            };
          })
        );

        const unreadMessagesMap = {};
        responses.forEach((res) => {
          unreadMessagesMap[res.userId] = res.unreadCount;
        });

        setUserUnreadMessages(unreadMessagesMap);
      } catch (error) {
        console.error("Erro ao buscar contagem de mensagens não lidas por usuário:", error);
      }
    }
  };

  // Função para buscar últimas mensagens (chamada apenas uma vez)
  const fetchLastMessagesForUsers = async () => {
    if (openCloseModalMessenger) {
      setIsLoadingConversations(true);
      try {
        const responses = await Promise.all(
          listAllUsers.map(async (item) => {
            const messagesResponse = await api.get(`/card/fetch-messages/${user.id}/${item.id}`);
            
            // Pega a última mensagem da conversa (última do array)
            const lastMessage = messagesResponse.data && messagesResponse.data.length > 0 
              ? messagesResponse.data[messagesResponse.data.length - 1] 
              : null;
            
            return { 
              userId: item.id, 
              lastMessage: lastMessage
            };
          })
        );

        const lastMessagesMap = {};
        responses.forEach((res) => {
          lastMessagesMap[res.userId] = res.lastMessage;
        });

        setUserLastMessages(lastMessagesMap);
      } catch (error) {
        console.error("Erro ao buscar últimas mensagens:", error);
      } finally {
        setIsLoadingConversations(false);
      }
    }
  };






  function getUserName(userId) {
    const user = listAllUsers.find(user => user.id === userId);
    return user ? user.username : 'Unknown';
  }

  async function closeMessageContainer() {
    setCurrentCardIdMessage(null);
    await markMessagesAsRead(user.id, destinatarioId);
    setListMessages([]);
    setVisibleCount(50); // Reset do contador de mensagens visíveis
    setOpenCloseModalMessage(false);
  }



  // const sortedUsers = [...listAllUsers].sort((a, b) => {
  //   const unreadA = userUnreadMessages[a.id] || 0;
  //   const unreadB = userUnreadMessages[b.id] || 0;
  //   return unreadB - unreadA;
  // });

  const sortedUsers = [...listAllUsers].sort((a, b) => {
    // Primeiro critério: Suporte sempre no topo
    if (a.user_type === 'Suporte') return -1;
    if (b.user_type === 'Suporte') return 1;
    
    // Segundo critério: Mensagens não lidas (maior quantidade primeiro)
    const unreadA = userUnreadMessages[a.id] || 0;
    const unreadB = userUnreadMessages[b.id] || 0;
    
    if (unreadA !== unreadB) {
      return unreadB - unreadA;
    }
    
    // Terceiro critério: Data da última mensagem (mais recente primeiro)
    const lastMessageA = userLastMessages[a.id];
    const lastMessageB = userLastMessages[b.id];
    
    if (lastMessageA && lastMessageB) {
      const dateA = new Date(lastMessageA.created_at);
      const dateB = new Date(lastMessageB.created_at);
      return dateB - dateA; // Mais recente primeiro
    }
    
    // Se um tem última mensagem e outro não, o que tem mensagem fica primeiro
    if (lastMessageA && !lastMessageB) return -1;
    if (!lastMessageA && lastMessageB) return 1;
    
    // Se nenhum tem mensagens, mantém ordem original
    return 0;
  });


  const filteredUsers = sortedUsers.filter(user =>
    user.username.toLowerCase().includes(searchTerm.toLowerCase())
  );



  function containsForbiddenWords(message) {
    const forbiddenWords = [
      'merda', 'porra', 'caralho', 'filha da puta', 'foda-se', 'cu', 'arrombado',
      'desgraça', 'buceta', 'corno', 'viado', 'puta', 'babaca', 'bosta', 'cacete',
      'escroto', 'otário', 'piroca', 'pau no cu', 'safado', 'chupa', 'piranha',
      'arrombada', 'vagabunda', 'trouxa', 'infeliz', 'imbecil', 'burro',
      'ignorante', 'canalha', 'cuzão', 'bicha', 'sapatão', 'meretriz',
      'nojento', 'moleque', 'vadia', 'escória', 'delinquente', 'debilóide',
      'cornudo', 'peido', 'imbecil', 'retardado', 'cretino', 'pilantra',
      'miserável', 'fedido', 'paspalho', 'palerma', 'panaca', 'pervertido',
      'otária', 'peidorreiro', 'boçal', 'bronco', 'estúpido', 'idiota', 'malcriado',
      'desmiolado', 'filho da mãe', 'desnaturado', 'desgraçado', 'demente',
      'esquisito', 'feio', 'grosseiro', 'idiotinha', 'imbeciloide', 'insensato',
      'lerdo', 'mal educado', 'malandro', 'nojento', 'pentelho', 'pistoleiro',
      'preguiçoso', 'prostituta', 'puta que pariu', 'puta merda', 'safado',
      'sem vergonha', 'tarado', 'tonto', 'vagabundo', 'vadio', 'velhaco', 'verme',
      'xexelento', 'xereta', 'xoxo'
    ];

    // Criando um padrão de regex para garantir que as palavras sejam verificadas isoladamente
    const forbiddenRegex = new RegExp(`\\b(${forbiddenWords.join('|')})\\b`, 'gi');

    return forbiddenRegex.test(message);
  }






  // ----------------- ROLAMEM ------------------



  // Adicione isso dentro da função `Messenger` após as variáveis de estado
  useEffect(() => {
    if (foundMessages.length > 0) {
      scrollToMessage(currentSearchIndex);
    }
  }, [currentSearchIndex]);

  const handleSearchMessages = () => {
    if (!searchInMessages.trim()) return;

    const found = listMessages
      .map((message, index) => ({
        ...message,
        index,
      }))
      .filter((msg) => {
        // Verifica se a mensagem contém o texto digitado
        const textMatch = msg.message.toLowerCase().includes(searchInMessages.toLowerCase());

        // Verifica se há informações do card e faz a busca nelas
        const cardMatch = msg.cardData && (
          (msg.cardData.name && msg.cardData.name.toLowerCase().includes(searchInMessages.toLowerCase())) ||
          (msg.cardData.document_number && msg.cardData.document_number.toString().includes(searchInMessages)) ||
          (msg.cardData.pedido_number && msg.cardData.pedido_number.toString().includes(searchInMessages))
        );

        return textMatch || cardMatch;
      });

    setFoundMessages(found);
    setCurrentSearchIndex(0);
    scrollToMessage(0);
  };


  const scrollToMessage = (index) => {
    if (foundMessages.length > 0 && index >= 0 && index < foundMessages.length) {
      const messageElement = document.getElementById(`message-${foundMessages[index].id}`);
      if (messageElement) {
        messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setCurrentSearchIndex(index);
      }
    }
  };





  const scrollToMessageReply = (messageId) => {
    if (!messageId) return;

    const attemptScroll = (retries = 10) => {
      const messageElement = document.getElementById(`message-${messageId}`);

      if (messageElement) {
        messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (retries > 0) {
        // Tenta novamente depois de um pequeno intervalo caso o elemento ainda não tenha sido renderizado
        setTimeout(() => attemptScroll(retries - 1), 300);
      }
    };

    attemptScroll();
  };




  useEffect(() => {
    const messageBody = document.querySelector('.message-body');
    if (!messageBody) return;

    const handleScroll = () => {
      const scrollTop = messageBody.scrollTop;
      const scrollHeight = messageBody.scrollHeight;
      const clientHeight = messageBody.clientHeight;
      
      // Debug logs
      console.log('Scroll Debug:', {
        scrollTop,
        scrollHeight,
        clientHeight,
        visibleCount,
        totalMessages: listMessages.length,
        isAtTop: scrollTop <= 10,
        hasMoreMessages: visibleCount < listMessages.length
      });
      
      // Detecta quando o usuário está no TOPO (mensagens mais antigas)
      // Usa threshold muito baixo (10px) para detectar quando chegou ao final
      if (scrollTop <= 10 && visibleCount < listMessages.length && !isLoadingMoreMessages) {
        console.log('🎯 CHEGOU AO FINAL - Carregando mais mensagens antigas...');
        setIsLoadingMoreMessages(true);
        
        // Salva a posição atual do scroll
        const currentScrollTop = messageBody.scrollTop;
        const currentScrollHeight = messageBody.scrollHeight;
        
        console.log('📍 Posição antes (automático):', { currentScrollTop, currentScrollHeight });
        
        setVisibleCount(prev => {
          const newCount = Math.min(prev + 50, listMessages.length);
          console.log(`📈 Carregando automaticamente de ${prev} para ${newCount} mensagens`);
          
          // Salva a posição atual para manter o scroll
          setSavedScrollPosition(currentScrollTop);
          setShouldMaintainScroll(true);
          
          setTimeout(() => {
            setIsLoadingMoreMessages(false);
          }, 100);
          
          return newCount;
        });
      }
    };

    messageBody.addEventListener('scroll', handleScroll);
    return () => messageBody.removeEventListener('scroll', handleScroll);
  }, [listMessages, visibleCount]);

  // useLayoutEffect para manter a posição do scroll quando carregamos mais mensagens
  useLayoutEffect(() => {
    if (shouldMaintainScroll) {
      const messageBody = document.querySelector('.message-body');
      if (messageBody) {
        messageBody.scrollTop = savedScrollPosition;
        console.log('🔧 useLayoutEffect - Restaurando posição:', savedScrollPosition);
        setShouldMaintainScroll(false);
      }
    }
  }, [visibleCount, shouldMaintainScroll, savedScrollPosition]);

  return (
    <div className='modal-messenger'>
      <div className='messenger-container'>
        <div className='header-messenger'>
          <label className='input-search-user-messenger-title'>Messenger</label>
          <button onClick={clearIdCardMessage} className='close-messenger-modal'>X</button>
          <input
            type="text"
            placeholder="Buscar usuário"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='input-search-user-messenger'
          />
        </div>


        <div className='messenger-body'>

          {isLoadingConversations ? (
            <div className="loading-conversations">
              <div className="spinner"></div>
              <p>Carregando conversas...</p>
            </div>
          ) : (
            filteredUsers &&
            filteredUsers.map((item) => (
              <div key={item.id} className='item-list-messenger' onClick={() => { openMessage(item) }}>
                <div className='user-logo-messenger-container'>
                  <img
                    src={item.avatar ? (item.avatar.includes('syncs-avatar') ? require(`../../assets/avatares/${item.avatar}`) : item.avatar) : logo}
                    className='messenger-logo-user'
                    alt={`${item.username}'s avatar`}
                  />
                </div>
                
                                 {/* Botão direto para marcar como não lida */}
                 <button
                   className='mark-unread-direct-button'
                   onClick={(e) => {
                     e.stopPropagation();
                     markMessagesAsUnread(user.id, item.id);
                   }}
                   title="Marcar como não lida"
                 >
                   📩
                 </button>
                <label className='messenger-username-label'>
                  <div className='column-messender-item-label'>
                    <label>{item.username}</label>
                    <div className='column-item-messenger-main'>

                      <label className='label-user-type-messenger-container' style={{ display: 'none', background: item.user_type == 'Administrador' ? 'red' : item.user_type == 'Supervisor' ? 'rgb(138, 224, 0)' : '' }}>{item.user_type}</label>
                      <label
                        className='label-user-type-messenger-container'
                        style={{
                          background:
                            item.user_type === 'Administrador' ? 'red' :
                              item.user_type === 'Supervisor Comercial' ? 'rgb(138, 224, 0)' :
                                item.user_type === 'Técnico' ? 'blue' :
                                  item.user_type === 'Comercial' ? 'orange' :
                                    item.user_type === 'Colaborador' ? 'purple' :
                                      item.user_type === 'Financeiro' ? 'teal' :
                                        item.user_type === 'Análise Técnica' ? 'darkblue' :
                                          item.user_type === 'Análise Comercial' ? 'darkgreen' :
                                            item.user_type === 'PCP' ? 'brown' :
                                              item.user_type === 'Assistência Técnica' ? 'gold' :
                                                item.user_type === 'Instalador' ? 'darkorange' :
                                                  item.user_type === 'Diretor' ? 'darkred' :
                                                    item.user_type === 'Marketing' ? 'violet' :
                                                      item.user_type === 'Pedidos' ? 'darkcyan' :
                                                        item.user_type === 'Vendedor Interno' ? 'coral' :
                                                          item.user_type === 'Orçamentos' ? 'darkslategray' :
                                                            item.user_type === 'Produção' ? 'slategray' :
                                                              item.user_type === 'Gerente' ? 'darkmagenta' :
                                                                item.user_type === 'Suporte' ? 'red' :
                                                                  ''
                        }}
                      >
                        {item.user_type}
                      </label>

                      <label className='label-state-messenger'>{item.state}</label>

                    </div>

                  </div>

                  <div className="conversation-status">
                    {userUnreadMessages[item.id] > 0 && (
                      <span className="mensagens-nao-lidas">{userUnreadMessages[item.id]}</span>
                    )}
                                         {userLastMessages[item.id] && (
                       <span className="last-message-time">
                         {(() => {
                           const lastMsg = userLastMessages[item.id];
                           const date = new Date(lastMsg.created_at);
                           const now = new Date();
                           const diffInHours = (now - date) / (1000 * 60 * 60);
                           
                           if (diffInHours < 24) {
                             // Se foi hoje, mostra apenas a hora
                             return format(date, 'HH:mm');
                           } else if (diffInHours < 48) {
                             // Se foi ontem
                             return 'Ontem';
                           } else if (diffInHours < 168) { // 7 dias
                             // Se foi esta semana, mostra o dia da semana
                             return format(date, 'EEEE', { locale: ptBR });
                           } else {
                             // Se foi há mais tempo, mostra a data
                             return format(date, 'dd/MM/yyyy');
                           }
                         })()}
                       </span>
                     )}
                  </div>


                </label>
              </div>
            ))
          )}



        </div>

        {user != null && openCloseModalMessage && (
          <div className='message-container'>
            <div className='message-header'>
              <MdOutlineArrowBackIos
                className='icons-back-message'
                onClick={() => {
                  closeMessageContainer()
                }}
              />
              <div className='user-logo-message-container'>
                {/* <img src={destinatarioAvatar} className='message-logo-user' alt={`${destinatarioName}'s avatar`} /> */}
                <img
                  src={destinatarioAvatar ? (destinatarioAvatar.includes('syncs-avatar') ? require(`../../assets/avatares/${destinatarioAvatar}`) : destinatarioAvatar) : logo}
                  className='message-logo-user'
                  alt={`${destinatarioName}'s avatar`}
                />







              </div>
              <label className='messenger-username-label-destinataria'>{destinatarioName}</label>
            </div>






            <div className='search-messages-container'>
              <input
                type='text'
                value={searchInMessages}
                onChange={(e) => setSearchInMessages(e.target.value)}
                placeholder='Localizar...'
                className='search-input-message'
              />
              <button onClick={handleSearchMessages} className='btn-search-message'>🔍</button>
              {/* {foundMessages.length > 0 && ( */}
              {true && (
                <div className='navigation-buttons'>
                  <button
                    onClick={() => setCurrentSearchIndex((currentSearchIndex - 1 + foundMessages.length) % foundMessages.length)}
                    className='btn-prev-message'
                  >
                    ⬆
                  </button>
                  <button
                    onClick={() => setCurrentSearchIndex((currentSearchIndex + 1) % foundMessages.length)}
                    className='btn-next-message'
                  >
                    ⬇
                  </button>
                </div>
              )}
            </div>







            <div className='message-body'>
              { loadingMessage || !isCardDataLoaded ? (
                <div className="loading-message">
                  <div className="spinner"></div>
                  <p>Carregando conversa...</p>
                </div>
              ) : (
                <>
                  {/* Indicador de mensagens antigas disponíveis */}
                  {visibleCount < listMessages.length && (
                    <div style={{ 
                      textAlign: 'center', 
                      padding: '10px', 
                      color: '#666', 
                      fontSize: '12px',
                      background: '#f0f0f0',
                      margin: '5px 0',
                      borderRadius: '5px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span>Role para cima para ver {listMessages.length - visibleCount} mensagens antigas</span>
                      <button
                        onClick={() => {
                          if (isLoadingMoreMessages) return;
                          
                          console.log('🔘 BOTÃO CLICADO - Carregando mais mensagens...');
                          setIsLoadingMoreMessages(true);
                          
                          const messageBody = document.querySelector('.message-body');
                          if (messageBody) {
                            const currentScrollTop = messageBody.scrollTop;
                            const currentScrollHeight = messageBody.scrollHeight;
                            
                            console.log('📍 Salvando posição:', { currentScrollTop, currentScrollHeight });
                            
                            setSavedScrollPosition(currentScrollTop);
                            setShouldMaintainScroll(true);
                          }
                          
                          setVisibleCount(prev => {
                            const newCount = Math.min(prev + 50, listMessages.length);
                            console.log(`📈 Carregando de ${prev} para ${newCount} mensagens`);
                            
                            setTimeout(() => {
                              setIsLoadingMoreMessages(false);
                            }, 100);
                            
                            return newCount;
                          });
                        }}
                        style={{
                          background: isLoadingMoreMessages ? '#ccc' : '#00aeff',
                          color: 'white',
                          border: 'none',
                          padding: '6px 12px',
                          borderRadius: '4px',
                          fontSize: '11px',
                          cursor: isLoadingMoreMessages ? 'not-allowed' : 'pointer',
                          fontWeight: 'bold'
                        }}
                        onMouseOver={(e) => !isLoadingMoreMessages && (e.target.style.background = '#0088cc')}
                        onMouseOut={(e) => !isLoadingMoreMessages && (e.target.style.background = '#00aeff')}
                        disabled={isLoadingMoreMessages}
                      >
                        {isLoadingMoreMessages ? 'Carregando...' : 'Carregar mais 50 mensagens'}
                      </button>
                    </div>
                  )}
                  
                  {listMessages.slice(-visibleCount).map((item) => (
                  <div
                    id={`message-${item.id}`}
                    key={item.id}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: item.id_remetente === user.id ? 'flex-end' : 'flex-start' }}
                    className='item-list-message'
                  >
                    {/* Se for uma resposta, exibir a mensagem original antes */}
                    {item.reply_to && (
                      <div className="reply-preview" onClick={() => scrollToMessageReply(item.reply_to)}>
                        <label className="reply-preview-label"></label>
                        {(() => {
                          const repliedMessage = listMessages.find(msg => msg.id === item.reply_to);
                          if (!repliedMessage) {
                            return <p className="reply-preview-message">Mensagem não encontrada</p>;
                          }
                          return (
                            <div className='reply-container-reply'>
                              {!repliedMessage.cardData && !repliedMessage.message.includes('card_id:') ? (
                                <p className="reply-preview-message">{repliedMessage.message}</p>
                              ) : (
                                <PreviewCard cardData={repliedMessage.cardData} />
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    )}

                    {!item.cardData && !item.message.includes('card_id:') && (
                      <label
                        style={{ backgroundColor: item.id_remetente === user.id ? 'rgb(78, 78, 78)' : 'white', color: item.id_remetente === user.id ? 'white' : 'rgb(78, 78, 78)' }}
                        className='message-label'
                      >
                        {item.message}
                      </label>
                    )}

                    {!item.cardData && item.message.includes('card_id:') && (
                      <label
                        style={{ backgroundColor: item.id_remetente === user.id ? 'rgb(78, 78, 78)' : 'white', color: item.id_remetente === user.id ? 'white' : 'rgb(78, 78, 78)' }}
                        className='message-label'
                      >
                        ⛔ Mensagem Bloqueada pelo ADM ⛔
                      </label>
                    )}

                    {item.cardData && typeof item.cardData === 'object' && item.cardData.column_id ? (
                      <div
                        style={{ backgroundColor: item.id_remetente === user.id ? 'rgb(78, 78, 78)' : 'white', color: item.id_remetente === user.id ? 'white' : 'rgb(78, 78, 78)' }}
                        className='message-label'
                      >
                        <PreviewCard cardData={item.cardData} />
                      </div>
                    ) : (
                      item.cardData && (
                        <label className="message-label" style={{ backgroundColor: 'lightgray', color: 'black' }}>
                          ❗ Dados do card indisponíveis ou inválidos
                        </label>
                      )
                    )}

                    <label className='date-message-label'>
                      {getUserName(item.id_remetente)} - {formatDate(item.created_at)}
                      {item.read ? (
                        user.id === item.id_remetente && <TbChecks className='icone-check-message' />
                      ) : (
                        user.id === item.id_remetente && <TbCheck className='icone-check-message' />
                      )}
                      <div className="message-options">
                        <IoReturnDownBack onClick={() => setReplyMessage(item)} className="reply-button" />
                      </div>
                    </label>
                  </div>
                  ))
                  }
                </>
              )}
              <div ref={messagesEndRef}></div>
            </div>




            <div className='message-footer'>
              <textarea
                ref={messageInputRef}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                className='message-input'
                placeholder='Mensagem'
                rows={1}
              />
              <MdSend className='icon-send-message' onClick={() => sendMessage(message)} />
            </div>
          </div>
        )}

        {replyMessage && (
          <div className="reply-container">
            <label className="reply-label">Respondendo a:</label>
            <div className="reply-message">

              {!replyMessage.cardData && !replyMessage.message.includes('card_id:') &&
                <p className='reply-message-msg'>{replyMessage.message}</p>
              }


              {replyMessage?.cardData && (
                <PreviewCard cardData={replyMessage.cardData} />
              )}




              <button onClick={() => setReplyMessage(null)} className="close-reply">X</button>
            </div>

          </div>
        )}


        <div className='footer-messenger-container'>

        </div>



      </div>


    </div>
  );
}

export default Messenger;
